import {trigger} from "../../../utils/events/trigger";
import {initWindow} from "./window";
import {initAsideSidebar} from "./aside.sidebar";

export const initScroll = () => {
	window.addEventListener(`scroll`, (evt) => {
		initWindow();
		initAsideSidebar();
	});
	
	trigger(window, `scroll`);
};
